export const FETCH_THEME_REQUEST = 'FETCH_THEME_REQUEST'
export const FETCH_THEME_SUCCESS = 'FETCH_THEME_SUCCESS'
export const FETCH_THEME_FAILURE = 'FETCH_THEME_FAILURE'

export const fetchTheme = (invoiceId) => {
  return {
    type: FETCH_THEME_REQUEST,
    invoiceId,
  }
}
